export default __webpack_public_path__ + "f41ee0e3f261a93461fc313a583ecf4d.png";